export default __webpack_public_path__ + "static/uiux-e3b23ae8251087e850fde848d74425ce.jpg";